/**
 * Centralized query key factory for React Query
 * All query keys should be defined here to ensure consistency
 */

export const queryKeys = {
  // Transactions
  transactions: {
    all: ['transactions'] as const,
    list: (filters?: { dateFrom?: string; dateTo?: string; type?: string }) =>
      [...queryKeys.transactions.all, 'list', filters] as const,
    recent: (months: number) =>
      [...queryKeys.transactions.all, 'recent', months] as const,
    byAccount: (accountId: string) =>
      [...queryKeys.transactions.all, 'account', accountId] as const,
  },

  // Accounts
  accounts: {
    all: ['accounts'] as const,
    list: () => [...queryKeys.accounts.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.accounts.all, 'detail', id] as const,
    fundingSources: () => [...queryKeys.accounts.all, 'fundingSources'] as const,
  },

  // Wallets
  wallets: {
    all: ['wallets'] as const,
    list: () => [...queryKeys.wallets.all, 'list'] as const,
    byAccount: (accountId: string) =>
      [...queryKeys.wallets.all, 'account', accountId] as const,
  },

  // Budgets
  budgets: {
    all: ['budgets'] as const,
    list: () => [...queryKeys.budgets.all, 'list'] as const,
    milestones: (budgetId?: string) =>
      [...queryKeys.budgets.all, 'milestones', budgetId] as const,
    spending: (period: { start: string; end: string }) =>
      [...queryKeys.budgets.all, 'spending', period] as const,
  },

  // Goals
  goals: {
    all: ['financial_goals'] as const,
    list: () => [...queryKeys.goals.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.goals.all, 'detail', id] as const,
  },

  // Recurring Transactions
  recurring: {
    all: ['recurring_transactions'] as const,
    list: () => [...queryKeys.recurring.all, 'list'] as const,
    active: () => [...queryKeys.recurring.all, 'active'] as const,
  },

  // Categories
  categories: {
    all: ['categories'] as const,
    byType: (type: 'income' | 'expense') =>
      [...queryKeys.categories.all, type] as const,
  },

  // User Preferences
  userPreferences: {
    all: ['user_preferences'] as const,
  },

  // Exchange Rates
  exchangeRates: {
    all: ['exchange_rates'] as const,
    forCurrencies: (currencies: string[], base: string) =>
      [...queryKeys.exchangeRates.all, base, currencies.sort().join(',')] as const,
  },
} as const;
